import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';

export const COLUMNS = (t) => [
    {
        label: t('search.subdomain_detail.table.subdomain'),
        key: 'subdomain',
        data: 'subdomain',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.week'),
        key: 'week',
        data: 'week',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.avg_weekly_urls'),
        key: 'urls',
        data: 'urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.avg_weekly_keywords'),
        key: 'keywords',
        data: 'keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.avg_position'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.subdomain_detail.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.00%')}</strong>;
        },
    },
];

export const chartKeys = (t) => [
    {
        key: 'clicks',
        label: t('search.subdomain_detail.chart.clicks'),
        icon: 'clicks',
        yAxisID: 'y3',
    },
    {
        key: 'impressions',
        label: t('search.subdomain_detail.chart.impressions'),
        icon: 'search',
    },
    {
        key: 'position',
        label: t('search.subdomain_detail.chart.position'),
        icon: 'pagev-view',
        yAxisID: 'y2',
        hidden: true,
    },
    {
        key: 'ctr',
        label: t('search.subdomain_detail.chart.ctr'),
        format: '0.00%',
        yAxisID: 'y4',
        render: (data) => numeral(data * 100).format('0.00'),
        icon: 'ctr',
        hidden: true,
    },
    {
        key: 'urls',
        label: t('search.subdomain_detail.chart.urls'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        type: 'bar',
    },
    {
        key: 'keywords',
        label: t('search.subdomain_detail.chart.keywords'),
        icon: 'pagev-view',
        yAxisID: 'y1',
        type: 'bar',
    },
];
